import styled from 'styled-components'
import type { ShelfLoadingProps } from './ShelfLoading'

export const Container = styled.div<ShelfLoadingProps>`
  height: ${({ height }) => height}px;
  display: flex;
  justify-content: center;
  align-items: center;
`
